import { useTranslation } from 'react-i18next';
import { Container } from './Tab.styled';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';

interface TabProps {
  active?: boolean;
  finished?: boolean;
  label: string;
  index: number;
}

const Tab = ({ active, finished, label, index }: TabProps) => {
  const { t } = useTranslation();
  const { isPhone } = useBreakpointFlag();

  return (
    <Container active={active} finished={finished}>
      {isPhone && !active ? `${index + 1}.` : `${index + 1}. ${t(label)}`}
    </Container>
  );
};

export default Tab;
